
import { defineComponent, PropType } from 'vue'
import useQuasar from 'quasar/src/composables/use-quasar.js';import useDialogPluginComponent from 'quasar/src/composables/use-dialog-plugin-component.js';
import { AgreementMember, useAgreementModule } from '@/modules/agreements'

export default defineComponent({
    name: 'agreement-purge-member',
    props: {
        agreementId: {
            type: String,
            required: true
        },
        member: {
            type: Object as PropType<AgreementMember>,
            required: true
        },
        memberName: {
            type: String,
            required: true
        }
    },
    setup (props) {
        const $q = useQuasar()
        const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()

        const { purgeAgreementMember, getAgreementMembers, getAgreementAvailableMembers } = useAgreementModule()

        const sendRequest = async () => await purgeAgreementMember(props.agreementId, {
            agreementId: props.agreementId,
            accessId: props.member.accessId,
            memberId: props.member.id
        })

        function onMemberPurge () {
            sendRequest()
                .then(() => {
                    onDialogOK()
                    $q.notify({
                        color: 'positive',
                        message: 'Member access has been purged'
                    })
                    getAgreementMembers(props.agreementId)
                    getAgreementAvailableMembers(props.agreementId)
                })
                .catch(err => {
                    $q.notify({
                        color: 'negative',
                        message: err?.message || 'system error'
                    })
                })
        }

        return {
            dialogRef,
            onDialogHide,
            onCancelClick: onDialogCancel,
            onMemberPurge
        }
    }
})
